import { createReducer, on } from '@ngrx/store';
import {
  LANGUAGE_FIND_SUCCESS,
  LANGUAGE_FAILURE,
  LANGUAGE_RESET_ERROR,
  LANGUAGE_RESET,
  LANGUAGE_CLEAR_STATE,
  LANGUAGE_UPDATE_LOADING,
} from '../actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  Idioma,
} from '@core/models';
import { LanguageEnum } from '@core/enums';
import { getDropdown } from '@core/helpers/general.helper';
import { MenuItem } from 'primeng/api';

export interface LanguageState {
  loading: boolean;
  currentLanguage: string|null;
  availableLanguages: MenuItem[];
  translations: Idioma;
  error: ResponseBadRequest | null;
}

export const initialState: LanguageState = {
  loading: false,
  currentLanguage: LanguageEnum.English,
  availableLanguages: getDropdown(LanguageEnum),
  translations: {},
  error: null,
};

export const languageReducer = createReducer(
  initialState,
  on(LANGUAGE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(LANGUAGE_FIND_SUCCESS, (state, { language, translations }) => ({ ...state, language, currentLanguage: language, translations })),
  on(LANGUAGE_FAILURE, (state, { error }) => ({ ...state, error })),
  on(LANGUAGE_RESET, (state) => ({ ...state, language: null, currentLanguage: null })),
  on(LANGUAGE_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(LANGUAGE_CLEAR_STATE, () => initialState),
);